<template>
  <div id="login_bg">
      <div id="bar">
        <div class="top">
            <div class="fl_l div-fl1"><a :href="links.kinx"><img src="@/assets/imgs/kinx_ci.png" alt=""></a></div>
            <div class="fl_l div-fl2"><img src="@/assets/imgs/kinx_fullname.png" alt=""></div>
            <div class="fl_r layout_right">
                <ul class="ta_r">
                    <li class="list">
                        <a :href="links.peering" target="_blank" class="highlight">{{strings.peering}}</a>
                        <span style="vertical-align: inherit;">|</span>
                    </li>
                    <li class="list">
                        <a :href="links.company" target="_blank">{{strings.company}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>





    <div id="background">
      <div class="box">
          <div class="boxin">
              <div class="title">
                  <span>{{ i18n.t("common.body.title01") }}</span>
                  <span>{{ i18n.t("common.body.title02") }}</span>
              </div>
              <div >
              <!-- start -->
              <form v-on:submit.prevent="submitForm">
                  <div>
                      <div>
                          <input v-show="true" type="text" name="memberid" ref="ref_mid" :placeholder="i18n.t('common.body.email')" spellcheck="false" :class="{'input_field_error':error.memberid.enable === true, 'input_field':!error.memberid.enable }" v-model="form.memberid" @keydown="clearError('e1')">
                      </div>
                  </div>

                  <div style="margin-top: 10px;">
                      <div class="password-input-container">
                          <input :type="form.passwordFieldType" v-show="true" name="password" ref="ref_pwd" :placeholder="i18n.t('common.body.password')" :class="{'input_field_error':error.password.enable === true, 'input_field':!error.password.enable }"  v-model="form.password"  @keydown="clearError('e2')" >
                          <span class="password-toggle-icon" @click="togglePasswordVisibility">
                            <svg v-if="form.passwordFieldType === 'password'" class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#858585" d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"/></svg>
                            <svg v-else class="eye-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#878787" d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/></svg>
                          </span>
                      </div>
                  </div>

                  <div class="idpw">
                      <div class="fl_l" style=" box-sizing: inherit;">
                        <label class="container">
                          <input type="checkbox" class="checkbox" v-model="form.saveid" value="saveid">
                          <span class="checkmark"></span>
                          <div class="id">{{ i18n.t("common.body.saveid") }}</div>
                        </label>
                      </div>
                      <div class="fl_r">
                          <a :href="links.findid" class="find">{{ i18n.t("common.body.findid") }}</a>
                          <div class="verticalline">|</div>
                          <a :href="links.findpw" class="find">{{ i18n.t("common.body.findpw") }}</a>
                      </div>
                  </div>


                  <div class="login">
                      <input class="login_bnt submit_btn" :value="i18n.t('common.body.login')" type="submit">
                  </div>
              </form>
              <!-- end -->
              </div>
              <div class="message-box">
                <ul v-show="errorCheck" class="message-ul">
                  <li v-for="item in errors" v-bind:key="item.id" style="white-space: pre;">
                    <div>
                      <div class="message-box-div-icon"><img src="@/assets/imgs/circle-exclamation.png" alt="" /></div>
                      <div  class="message-box-div-message" :style="{float:'left'}">{{ i18n.t(`message.${item.msg}`) }}</div>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="line"></div>
              <p>* {{ i18n.t("common.contact.contact") }} : <a :href="links.contact" target="_blank" class="login-contact-online">{{ i18n.t("common.contact.online") }}</a> / {{ i18n.t("common.contact.phone01") }}</p>


          </div>
      </div>
    </div>






    <div id="footer">
        <div style="width: 1200px; margin: 0 auto;">
            <div class="footer_r"><span>©KINX Inc. All Rights Reserved.</span></div>
            <div v-if="locale === 'en'" >
                <span class="kinx_kr">{{ i18n.t("common.footer.kinx") }}</span>
                <span class="kinx_en">Korea Internet Neutral Exchange</span>
                <a :href="links.agreement3" target="_blank" class="footer_l"><span>{{strings.agreement3}}</span></a>
            </div>
            <div v-else >
                <span class="kinx_kr">{{ i18n.t("common.footer.kinx") }}</span>
                <span class="kinx_en">Korea Internet Neutral Exchange</span>
                <a :href="links.agreement1" target="_blank" class="footer_l"><span>{{strings.agreement1}}</span></a>
                <span class="kinx_en"> | </span>
                <a :href="links.agreement2" target="_blank" class="footer_l"><span>{{strings.agreement2}}</span></a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueCookies from 'vue-cookies'
import Swal from 'sweetalert2';
import { i18n } from '@/i18n'

let queryString   = window.location.search;
let urlParams     = new URLSearchParams(queryString);
let response_type = urlParams.get('response_type');
let client_id     = urlParams.get('client_id');
let redirect_uri  = urlParams.get('redirect_uri');
let state         = urlParams.get('state');
let scope         = urlParams.get('scope');

let ckKSid  = VueCookies.get('KX_POTL_DIAS_MRED');
let kinxSid = (ckKSid !== undefined && ckKSid !== null && ckKSid !== '') ? CryptoJS.AES.decrypt(ckKSid, 'secretKey').toString(CryptoJS.enc.Utf8) : '';

export default {
  name: "App",
  data(){
    let locale = VueCookies.get('KX_POTL_LANG');
    return {
      strings:{
        language:(locale=='en') ? "English" : "Korean",
        peering:"과천 IDC",
        company:"Company",
        agreement1:"이용약관",
        agreement2:"개인정보처리방침",
        agreement3:"General Terms & Conditions",
      },
      links:{
        kinx:"https://www.kinx.net/",
        peering:"https://www.kinx.net/infrastructure/dc/gwacheon/",
        company:"https://company.kinx.net/",
        agreement1:"https://www.kinx.net/agreements/agreements/agreement01/",
        agreement2:"https://www.kinx.net/agreements/agreements-3/",
        agreement3:"https://www.kinx.net/agreements/?lang=en",
        contact:"https://www.kinx.net/contact/",
        findid:`${process.env.VUE_APP_CUSTOMER_PORTAL}/member/findid`,
        findpw:`${process.env.VUE_APP_CUSTOMER_PORTAL}/member/findpw`,
      },
      locale:i18n.locale,
      i18n,
      form: {
        memberid: kinxSid,
        password: '',
        saveid: (kinxSid == '') ? [] : ['saveid'],
        client_id:client_id,
        response_type:response_type,
        redirect_uri:redirect_uri,
        state:state,
        scope:scope,
        passwordFieldType: 'password',
      },
      errorCheck: false,
      error: {
        memberid: {enable : false},
        password: {enable : false},
      },
      errors:[],
    }
  },
  methods:{
    chekParameter: function() {
      const Toast = Swal.mixin({
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        },
        willClose: () => {
          history.back(-1);
        }
      });

      if(response_type !== 'code' || client_id == '' || redirect_uri=='' || state=='') {
        Toast.fire({
          title: 'Error!',
          text: i18n.t("message.connect_error"),
          icon: 'error',
          showConfirmButton: false,
          closeOnClickOutside: false,
        })
      }
    },
    changeLocale(){
      i18n.locale = (this.locale=='ko') ? "en" : "ko";
      this.locale = (this.locale=='ko') ? "en" : "ko";
      this.$refs.language.textContent = (this.locale=='en') ? "English" : "Korean";

      VueCookies.set('KX_POTL_LANG', i18n.locale, 0, '/', '.kinx.net');
    },
    validationCheck() {
      let chkfocus = false;
      this.errorCheck = false;
      this.errors = [];
      if (!this.form.memberid) {
        this.error.memberid.enable = true;
        this.errorCheck = true;
        this.errors.push({id:"e1", msg:"input_error.memberid"});
        this.$refs.ref_mid.focus();
        chkfocus = true;
      }

      if (!this.form.password) {
        this.error.password.enable = true;
        this.errorCheck = true;
        this.errors.push({id:"e2", msg:"input_error.password"});
        if (!chkfocus) {
          this.$refs.ref_pwd.focus();
        }
      }
    },
    clearError(itemId) {
      itemId == "e1" ? this.error.memberid.enable = false : this.error.password.enable = false;
      this.errors = this.errors.filter((obj) => {
        return obj.id !== itemId;
      });
    },
    clearForm() {
      this.form.memberid = '';
      this.form.password = '';
    },
    togglePasswordVisibility() {
      this.form.passwordFieldType = this.form.passwordFieldType === 'password' ? 'text' : 'password';
    },
    submitForm() {
      this.validationCheck();

      if(this.form.saveid[0] === undefined) {
        VueCookies.remove('KX_POTL_DIAS_MRED');
      }

      if (!this.errorCheck && this.errors.length == 0) {
        axios.post(process.env.VUE_APP_AUTH_URL, this.form, {
          headers: {
            "Content-Type": `application/json`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            if(this.form.saveid[0] !== undefined && this.form.saveid[0]=='saveid') {
              let memberId = CryptoJS.AES.encrypt(this.form.memberid, 'secretKey').toString();
              VueCookies.set('KX_POTL_DIAS_MRED', memberId);
            }

            if(typeof res.data.redirect_uri !== 'undefined' && res.data.redirect_uri != '') {
              window.location.href = res.data.redirect_uri;
            }
            else {
              this.errorCheck = true;
              this.errors.push({id:"e3", msg: "login_error.error01"});
            }
          }

        })
        .catch((e) => {
          let mag_element = ''
          mag_element = (e.response.data.error=='Failed more 5') ? 'login_error.error03' : 'login_error.error01';
          mag_element = (e.response.data.error=='invalid_user') ? 'login_error.error02' : mag_element;

          this.errorCheck = true;
          this.errors.push({id:"e3", msg: mag_element});
        })
        .finally(() => {
          //this.clearForm();
        });
      }
    }
  },
  beforeMount(){
    // this.chekParameter();
  },
};
</script>

<style>
@import "./assets/css/style.css";
</style>

